import { IUserCategoryBase } from '../../models/userCategories';
import {
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
} from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateUserProps {
  userId: string;
  blockExpiresAt?: Date | null;
  isBlocked: boolean;
}

interface IUpdateUserBlockCategories extends IUserCategoryBase {
  venture: IVentureBase;
}

interface IUserAssignment extends IUserAssignmentBase {
  venture?: IVentureBase;
}

export interface IUpdatedUser extends IUserBase {
  categories: IUpdateUserBlockCategories[];
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

export const updateUserBlocksService = async ({
  userId,
  blockExpiresAt,
  isBlocked,
}: IUpdateUserProps): Promise<IUpdatedUser> => {
  const { data } = await jhsfBookingsApi.patch<IUpdatedUser>(
    `/users/${userId}/blocks`,
    {
      blockExpiresAt,
      isBlocked,
    },
  );

  return data;
};
